import { Controller } from 'stimulus';

export default class extends Controller {

  static targets = ["form", "saveDialog"]

  connect() {
    // Autosave every 20 seconds
    setInterval(this.save, 20000);
  }

  showConfirmation = (data) => {
    this.saveDialogTarget.querySelector("span").innerText = (new Date).toLocaleTimeString("fr-FR");
    this.saveDialogTarget.style.display = "flex"
  }

  save = () => {
    Rails.ajax({
      url: this.formTarget.action + ".js",
      type: this.formTarget.method,
      data: new FormData(this.formTarget),
      success: this.handleResponse
    })
  }

  handleResponse = (response) => {
    const parsedResponse = JSON.parse(response)
    switch (parsedResponse.action) {
      case 'delete':
        const deletedTaskFields = this.formTarget.querySelector(`#task_${parsedResponse.data.id}`);
        deletedTaskFields.remove();
        break;
      case 'update':
        const tasks = parsedResponse.data.operations
        if (!tasks) { return };

        let taskIdInput;
        tasks.forEach(task => {
          // Caveat: For the first item of nested attributes, the id 1 is always used instead of the custom ID
          if (task === tasks[1]) {
            taskIdInput = this.formTarget.querySelector(`#mode_operatoire_operations_attributes_1_id`);
          } else {
            taskIdInput = this.formTarget.querySelector(`#mode_operatoire_operations_attributes_${task.form_id}_id`);
          }
          if (!taskIdInput) {
            return;
          } else if (!taskIdInput.value) {
            taskIdInput.value = task.id
          }
        })
        this.showConfirmation();
        break;
    }
  }
}
